// src/pages/Practice.jsx
import React, { useEffect, useState } from "react";
import { useParams, Link, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { HiOutlineArrowNarrowRight } from "react-icons/hi";

const GRADES = ["9", "10", "11", "12"];
const EXAMS = [
  { title: "First Mid Term", key: "first-mid-term" },
  { title: "Quarterly", key: "quarterly" },
  { title: "Second Mid Term", key: "second-mid-term" },
  { title: "Half Yearly", key: "half-yearly" },
  { title: "Third Mid Term", key: "third-mid-term" },
  { title: "First Revision", key: "first-revision" },
  { title: "Second Revision", key: "second-revision" },
  { title: "Third Revision", key: "third-revision" },
  { title: "Model Board", key: "model-board" },
  { title: "Study Materials", key: "study-materials" },
];

const SUBJECTS_9_10 = [
  { title: "தமிழ்", key: "tamil" },
  { title: "English", key: "english" },
  { title: "Mathematics", key: "mathematics" },
  { title: "Science", key: "science" },
  { title: "Social Science", key: "social-science" },
];

const SUBJECTS_11_12 = [
  { title: "தமிழ்", key: "tamil" },
  { title: "English", key: "english" },
  { title: "Physics", key: "physics" },
  { title: "Chemistry", key: "chemistry" },
  { title: "Mathematics", key: "mathematics" },
  { title: "Biology", key: "biology" },
  { title: "Computer Science", key: "computer-science" },
  { title: "Computer Application", key: "computer-application" },
  { title: "Botany", key: "botany" },
  { title: "Zoology", key: "zoology" },
  { title: "Economics", key: "economics" },
  { title: "Commerce", key: "commerce" },
  { title: "Accountancy", key: "accountancy" },
  { title: "History", key: "history" },
  { title: "Business Maths", key: "business-maths" },
];


export function Practice() {
  const { grade, examKey } = useParams();
  const navigate = useNavigate();
  const [subjects, setSubjects] = useState([]);

  // once both grade+examKey exist, pick the right subject list
  useEffect(() => {
    if (grade && examKey) {
      if (["9", "10"].includes(grade)) setSubjects(SUBJECTS_9_10);
      else setSubjects(SUBJECTS_11_12);
    }
  }, [grade, examKey]);

  // 1) No grade param → pick a grade
  if (!grade) {
    return (
      <section className="container mx-auto py-12">
        <h2 className="text-3xl font-bold text-pink-600 text-center mb-8">
          Choose Your Class
        </h2>
        <div className="flex justify-center gap-6 flex-wrap">
          {GRADES.map((g) => (
            <motion.div
              key={g}
              onClick={() => navigate(`/practice/${g}`)}
              whileHover={{ scale: 1.05 }}
              className="w-36 h-36 bg-pink-100 text-pink-600 rounded-lg shadow-lg flex items-center justify-center cursor-pointer font-bold text-xl"
            >
              Class {g}
            </motion.div>
          ))}
        </div>
      </section>
    );
  }

  // 2) grade exists but examKey missing → pick an exam
  if (grade && !examKey) {
    return (
      <section className="container mx-auto py-12">
        <button
          onClick={() => navigate(-1)}
          className="text-pink-600 mb-6 underline"
        >
          ← Back to Classes
        </button>
        <h2 className="text-3xl font-bold text-pink-600 text-center mb-8">
          Class {grade} Papers
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
          {EXAMS.map((exam) => (
            <motion.div
              key={exam.key}
              onClick={() => navigate(`/practice/${grade}/${exam.key}`)}
              whileHover={{ scale: 1.03 }}
              className="bg-white rounded-lg shadow p-6 flex flex-col items-center justify-center cursor-pointer"
            >
              <HiOutlineArrowNarrowRight className="text-pink-600 text-3xl mb-3" />
              <span className="text-gray-800 font-medium text-center">
                {exam.title}
              </span>
            </motion.div>
          ))}
        </div>
      </section>
    );
  }

  // 3) both grade + examKey → pick a subject
  return (
    <section className="container mx-auto py-12">
      <button
        onClick={() => navigate(-1)}
        className="text-pink-600 mb-6 underline"
      >
        ← Back to Exams
      </button>
      <h2 className="text-3xl font-bold text-pink-600 text-center mb-8">
        Class {grade} – {examKey.replace(/-/g, " ")} Subjects
      </h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
        {subjects.map((sub) => (
          <Link
            key={sub.key}
            to={`/resources/${examKey}/${grade}/${sub.key}`}
          >
            <motion.div
              whileHover={{ scale: 1.05 }}
              className="bg-white rounded-lg shadow p-6 text-center cursor-pointer"
            >
              <span className="text-gray-800 font-medium">{sub.title}</span>
            </motion.div>
          </Link>
        ))}

      </div>
    </section>
  );
}

export default Practice;
